import { Input, Button } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { useEventDraft } from '../../../context/useEventDraft.js';

/**
 * Editable value pre-populated with the proposed value. The "Reset to proposed
 * value" affordance only appears once the reviewer diverges from the proposal.
 * Lives in the detail body; the decision footer reads the same draft via
 * EventDraftProvider (`key={event.id}`). Until the reviewer types, `editing`
 * is false and the input shows the proposed value — no seed effect needed.
 */
function EditBlock({ detail }) {
  const { t } = useTranslation('work-queues-app');
  const { draft, setDraft, editing } = useEventDraft();
  const proposed = detail?.proposedValue ?? '';

  if (!detail) return null;

  const value = editing ? draft : proposed;

  return (
    <div className="border-t border-edge pt-5">
      <div className="flex min-h-6 items-center justify-between gap-3">
        <p className="text-xs font-semibold uppercase tracking-wide text-content-faint">
          {t('trainMe.edit')}
        </p>
        {value !== proposed && (
          <Button
            variant="tertiary"
            size="sm"
            className="underline-offset-2 hover:underline"
            onClick={() => setDraft(proposed)}
          >
            {t('trainMe.resetToProposed')}
          </Button>
        )}
      </div>
      <Input
        className="mt-2"
        value={value}
        aria-label={detail.fieldName}
        onChange={(changeEvent) => setDraft(changeEvent.target.value)}
      />
    </div>
  );
}

export default EditBlock;
